export default __webpack_public_path__ + "static/media/kjukebox.2bec2674.png";